import axios from "axios";
// config
import {
  HOST_API_KEY,
  PULSE_URL,
  YT_CREATOR_DISCOVERY_API,
  YT_CREATOR_DISCOVERY_API_KEY,
} from "../config-global";

// ----------------------------------------------------------------------

// Some endpoints serialize Python floats and emit bare `NaN` / `Infinity`
// tokens (e.g. `"sentiment": NaN`). Those are invalid JSON, so axios' default
// transform silently hands back the raw string and callers end up reading
// properties off a 28KB string. Replace the non-finite tokens (never inside a
// string literal) and parse again.
const sanitizeNonFiniteTokens = (text) =>
  text.replace(/"(?:[^"\\]|\\.)*"|\bNaN\b|-?\bInfinity\b/g, (match) =>
    match.startsWith('"') ? match : "null",
  );

const parseResponse = (data) => {
  if (typeof data !== "string" || data === "") return data;

  try {
    return JSON.parse(data);
  } catch {
    try {
      return JSON.parse(sanitizeNonFiniteTokens(data));
    } catch {
      // Not JSON at all (CSV, plain text, ...) — keep axios' default behaviour.
      return data;
    }
  }
};

const axiosInstance = axios.create({
  baseURL: HOST_API_KEY,
  transformResponse: [parseResponse],
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) =>
    Promise.reject(
      (error.response && error.response.data) || "Something went wrong",
    ),
);

export const pulseAxiosInstance = axios.create({
  baseURL: PULSE_URL,
  transformResponse: [parseResponse],
});

pulseAxiosInstance.interceptors.response.use(
  (response) => response,
  (error) =>
    Promise.reject(
      (error.response && error.response.data) || "Something went wrong",
    ),
);

// YouTube creator discovery. A standalone API Gateway (not the Pantheon
// gateway), guarded by a shared key rather than the Cognito authorizer.
export const discoveryAxiosInstance = axios.create({
  baseURL: `${YT_CREATOR_DISCOVERY_API.replace(/\/$/, "")}/v1`,
  headers: YT_CREATOR_DISCOVERY_API_KEY
    ? { "x-api-key": YT_CREATOR_DISCOVERY_API_KEY }
    : {},
});

discoveryAxiosInstance.interceptors.response.use(
  (response) => response,
  (error) =>
    Promise.reject(
      (error.response && error.response.data) || "Something went wrong",
    ),
);

export default axiosInstance;
